var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 45,
    viewBox: "0 0 40 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 45,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_207_2",
    transform: "scale(0.025 0.0222222)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_207_2",
    width: 40,
    height: 45,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAtCAYAAADcMyneAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAACxMAAAsTAQCanBgAAAH3SURBVFhH7djBTsIwGMDxQRwaE5XFxMSbxhMJT+CNl8BH8OTjmHjwzBNw4+CTePJgsgMhOxAFEuzHvi4dLV2/fi1y4J+YdXNsPysFQhKil6fkIT+5XKs/49dOD3/Nqo1bVr37tIvDqs+v9TkOWQUBxuwI5GYEyic67kbPdj8NqJ64D2TT/WpA0wkxkS73U4EpbrViIF2vqQKXN6viFMdaIZG2awlDB4ebtp+Di9hIB9yy3CvTFokoGpKKg0xAKDjSBwftAkLBkL44yAaE2EgODmoCQt7IBlxLbKw4CE5yrSNu+ItjVi4zJ6MAITaSgoOoQMgbScVBPkCIjPTBQS3bE/kQclnF/9oRyM13kTi9i6jhCzM5rwf5LiwfJPkB3FVPRZJODvWSREE6LxIb7v15/ojDqjfDMRnlD3UC2i4I7xDdi9YCd6uuxDHbTLkiG4FNOLGxvn2Jc1ifJ61ALg5jfejdCQyEk3kjjcDAOJkXUgNGwsnIyBowMk5GQqrAnd/NBMTJrEg1FbhMJ0WG4ypxIXgtC4mTGZHiWG2iav/ibJDM8lFxjbty5mJWQ+ajBO69KvfKtEXSHyZTmEnExZi57TbIdNLO+sNiiseqNCAEMyk2+8DJFtlgBvfUMgIPqSOQG+kDq63vj7M7HG66HfzkYjMv93xLkj90kRVZzzHs3AAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.02623eeee46fbd7dd4a3e126354809b9.svg";
export { ForwardRef as ReactComponent };